import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ProfileService } from '../services/profile.service';
import { catchError, map, of, switchMap } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const profileService = inject(ProfileService);

  if (authService.isAuthenticated()) {
    return ensureProfileLoaded(authService, profileService);
  }

  const refresh = authService.getRefreshToken();
  if (!refresh) {
    authService.sessionExpired();
    return false;
  }

  return authService.refreshAccessToken().pipe(
    switchMap(() => {
      if (!authService.isAuthenticated()) {
        authService.sessionExpired();
        return of(false);
      }
      return ensureProfileLoaded(authService, profileService);
    }),
    catchError(() => {
      authService.sessionExpired();
      return of(false);
    })
  );
};

function ensureProfileLoaded(
  authService: AuthService,
  profileService: ProfileService
) {
  if (profileService.loaded()) {
    return of(true);
  }

  return profileService.getProfile().pipe(
    map(() => true),
    catchError(() => {
      authService.sessionExpired();
      return of(false);
    })
  );
}
